import {IHttpService, IIntervalService, ILogService, IPromise} from 'angular';
import {TSDocumentType} from '../../models/enums/TSDokumentType';
import TSDownloadFile from '../../models/TSDownloadFile';
import DVBernUtil from '../../utils/DVBernUtil';

export class DownloadRS {
    serviceURL: string;
    http: IHttpService;

    log: ILogService;

    static $inject = ['$http', 'REST_API', '$log', '$window', '$interval'];

    /* @ngInject */
    constructor($http: IHttpService, REST_API: string, $log: ILogService, private $window: ng.IWindowService,
                private $interval: IIntervalService) {
        this.serviceURL = REST_API + 'blobs/temp';
        this.http = $http;
        this.log = $log;
    }

    public getAccessTokenDocumentById(documentId: string): IPromise<TSDownloadFile> {
        let url = this.serviceURL + '/dokument/' + encodeURIComponent(documentId);

        return this.http.get(url)
            .then((response: any) => {
                this.log.debug('PARSING DownloadFile REST object ', response.data);
                return new TSDownloadFile().deserialize(response.data);
            });
    }

    public getAccessTokenDocument(fallId: string, doctype: TSDocumentType, documentId: string,
                                  parentId?: string): IPromise<TSDownloadFile> {
        //parentId is not always set > pass as query param
        let url = this.serviceURL + '/' + encodeURIComponent(fallId) + '/typ/'
            + encodeURIComponent(TSDocumentType[doctype]) + '/dokument/' + encodeURIComponent(documentId);
        if (parentId !== undefined) {
            url = url += '?parentId=' + parentId;
        }

        return this.http.get(url)
            .then((response: any) => {
                this.log.debug('PARSING DownloadFile REST object ', response.data);
                return new TSDownloadFile().deserialize(response.data);
            });
    }

    public getServiceName(): string {
        return 'DownloadRS';
    }

    /**
     *
     * @param accessToken
     * @param dokumentName
     * @param attachment
     * @param myWindow -> Das Window muss als Parameter mitgegeben werden, damit der Popup Blocker das Oeffnen dieses
     *         Fesnters nicht als Popup identifiziert.
     * @returns {boolean}
     */
    public startDownload(accessToken: string, dokumentName: string, attachment: boolean, myWindow: Window) {
        if (myWindow) {
            let href: string = this.serviceURL + '/blobdata/' + accessToken;
            if (attachment) {
                // add MatrixParam for to download file instead of opening it inline
                href = href + ';attachment=true;';
            } else {
                myWindow.focus();
            }
            //as soon as the window is ready send it to the download

            this.redirectWindowToDownloadWhenReady(myWindow, href, accessToken);

            //This would be the way to open file in new window (for now it's better to open in new tab)
            //this.$window.open(href, name, 'toolbar=0,location=0,menubar=0');
        } else {
            this.log.error('Download popup window was not initialized');
        }
    }

    prepareDownloadWindow(): Window {
        return this.$window.open('./src/assets/downloadWindow/downloadWindow.html', DVBernUtil.generateRandomName(5))!;
    }

    private redirectWindowToDownloadWhenReady(win: Window, href: string, name: string) {
        //wir pruefen den dokumentstatus alle 100ms, insgesamt maximal 300 mal
        let readyTimer: IPromise<any> = this.$interval(() => {
            if (win.document.readyState !== 'complete') {
                return;
            }
            this.$interval.cancel(readyTimer);
            //do stuff
            this.hideSpinner(win);
            this.addCloseButtonHandler(win);
            win.open(href, win.name);
        }, 100, 300);
    }

    /**
     * Es kann sein, dass das popup noch gar nicht fertig gerendert ist bevor wir den spinner schon wieder verstecken
     * wollen in diesem fall warten wir noch bis das popup in den readyState 'conplete' wechselt und verstecken den
     * spinner dann
     */
    public hideSpinner(win: Window) {
        this.log.debug('hiding spinner');
        let element = win.document.getElementById('spinnerCont');
        if (element) {
            element.style.display = 'none';
        } else {
            console.log('element not found, can not hide spinner');
        }
        let buttonElement = win.document.getElementById('closeButton');
        if (buttonElement) {
            buttonElement.style.display = 'block';
        }

    }

    public addCloseButtonHandler(win: Window) {
        let element = win.document.getElementById('closeButton');
        if (element) {
            element.addEventListener('click', () => {
                win.close();
            }, false);
        } else {
            console.log('element not found, can not attach window close handler spinner');
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/downloadRS.rest.ts